/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

#card-handover-to {
  .MuiFormGroup-root.MuiRadioGroup-root {
    height: 260px;
    column-gap: variables.$gap-between-lists;
  }

  > div.MuiFormControl-root.MuiTextField-root:nth-child(3) {
    margin-top: variables.$margin-large;
  }
}
